import React, { createContext, useContext, useState, useEffect } from 'react';

const CustomerContext = createContext();

// Durée de validité de la session vendor (24 heures)
const VENDOR_SESSION_DURATION = 24 * 60 * 60 * 1000;

export function CustomerProvider({ children }) {
  const [activeCustomer, setActiveCustomer] = useState(null);
  const [activeCards, setActiveCards] = useState([]);
  const [isVendorAuthenticated, setIsVendorAuthenticated] = useState(false);
  const [vendorName, setVendorName] = useState('');
  const [vendorCode, setVendorCode] = useState('');
  const [isAdmin, setIsAdmin] = useState(false);
  const [sessionChecked, setSessionChecked] = useState(false); // Flag pour indiquer que la session a été vérifiée

  // Charger la session vendor depuis localStorage au démarrage
  useEffect(() => {
    const savedSession = localStorage.getItem('vendorSession');
    if (savedSession) {
      try {
        const session = JSON.parse(savedSession);
        const now = Date.now();
        
        // Vérifier si la session n'a pas expiré
        if (session.expiresAt && now < session.expiresAt) {
          setIsVendorAuthenticated(true);
          setVendorName(session.vendorName || '');
          setVendorCode(session.vendorCode || '');
          setIsAdmin(session.isAdmin || false);
          console.log('✅ Session vendor restaurée:', session.vendorName);
        } else {
          // Session expirée, la supprimer
          localStorage.removeItem('vendorSession');
          console.log('⏰ Session vendor expirée');
        }
      } catch (e) {
        localStorage.removeItem('vendorSession');
      }
    }
    // Marquer que la vérification de session est terminée
    setSessionChecked(true);
  }, []);

  // Sauvegarder la session vendor quand elle change
  useEffect(() => {
    if (isVendorAuthenticated && vendorName) {
      const session = {
        vendorName,
        vendorCode,
        isAdmin,
        expiresAt: Date.now() + VENDOR_SESSION_DURATION,
        savedAt: new Date().toISOString()
      };
      localStorage.setItem('vendorSession', JSON.stringify(session));
      console.log('💾 Session vendor sauvegardée');
    }
  }, [isVendorAuthenticated, vendorName, vendorCode, isAdmin]);

  // Fonction pour se déconnecter (efface la session)
  const logoutVendor = () => {
    setIsVendorAuthenticated(false);
    setVendorName('');
    setVendorCode('');
    setIsAdmin(false);
    localStorage.removeItem('vendorSession');
    console.log('👋 Session vendor supprimée');
  };

  return (
    <CustomerContext.Provider value={{ 
      activeCustomer, 
      setActiveCustomer, 
      activeCards, 
      setActiveCards,
      isVendorAuthenticated,
      setIsVendorAuthenticated,
      vendorName,
      setVendorName,
      vendorCode,
      setVendorCode,
      isAdmin,
      setIsAdmin,
      sessionChecked,
      logoutVendor
    }}>
      {children}
    </CustomerContext.Provider>
  );
}

export function useCustomer() {
  const context = useContext(CustomerContext);
  if (!context) {
    throw new Error('useCustomer must be used within CustomerProvider');
  }
  return context;
}